import { ParticipanteResponse } from 'common/genericTypes';
import { AutoComplete } from 'm2m.components';
import React from 'react';
import { Typography, Paper } from '@material-ui/core';
import _ from 'lodash';
import { addCpfCnpjMask } from 'utils/mask';
import { stripCpfCnpjFormatting } from 'utils/validation';
import { TextField as MUITextField } from '@material-ui/core';
import { isValidElement } from 'react';

interface Props {
  label: string;
  participantes: Array<ParticipanteResponse>;
  participante: ParticipanteResponse | null;
  onChange: (participante: ParticipanteResponse | null) => void;
  error?: boolean;
  disabled?: boolean;
  popupIndicatorTestId?: string;
}

const ParticipanteAutoComplete: React.FC<Props> = (props) => {
  const { label, participantes, participante, onChange, error, disabled, popupIndicatorTestId } = props;

  const applyPopupIndicatorTestId = (node: React.ReactNode): React.ReactNode => {
    if (!popupIndicatorTestId) return node;
    if (!isValidElement(node)) return node;

    const element = node as React.ReactElement<any>;
    const className = typeof element.props?.className === 'string' ? element.props.className : '';
    const ariaLabel = typeof element.props?.['aria-label'] === 'string' ? element.props['aria-label'] : '';
    const title = typeof element.props?.title === 'string' ? element.props.title : '';

    const isPopupIndicator =
      className.includes('MuiAutocomplete-popupIndicator') || ariaLabel.toLowerCase() === 'open' || title.toLowerCase() === 'open';

    if (isPopupIndicator) {
      return React.cloneElement(element, { 'data-testId': popupIndicatorTestId });
    }

    if (!element.props?.children) return element;

    const children = React.Children.map(element.props.children, (child) => applyPopupIndicatorTestId(child));
    return React.cloneElement(element, undefined, children);
  };

  const filterParticipantes = (options: Array<ParticipanteResponse>, value: string) => {
    var valueUpperCase = value.toUpperCase();
    const valueClean = stripCpfCnpjFormatting(value);
    return options.filter(
      (op) =>
        op.razaoSocial.toLocaleUpperCase().includes(valueUpperCase) ||
        (valueClean.length > 0 && stripCpfCnpjFormatting(op.cnpj).includes(valueClean))
    );
  };

  return (
    <AutoComplete
      label={label}
      placeholder={'Pesquisar...'}
      options={participantes}
      getOptionLabel={(option: ParticipanteResponse) => addCpfCnpjMask(option.cnpj)}
      value={participante}
      onChange={onChange}
      disabled={disabled}
      filterOptions={(options: Array<ParticipanteResponse>, state) => filterParticipantes(options, state.inputValue)}
      filterSelectedOptions
      PaperComponent={({ children }) => <Paper style={{ width: '500px', height: '100%' }}>{children}</Paper>}
      renderOption={(option: ParticipanteResponse) => (
        <div style={{ width: '100%' }}>
          <div style={{ display: 'flex' }}>
            <Typography style={{ margin: 'auto 12px' }}>{addCpfCnpjMask(option.cnpj)}</Typography>
          </div>
          <div>
            <Typography style={{ margin: 'auto 12px' }} variant="body2">
              {option.razaoSocial}
            </Typography>
          </div>
        </div>
      )}
      helperText={participante?.razaoSocial}
      renderInput={(params) => (
        <MUITextField
          {...params}
          label={label}
          variant="outlined"
          placeholder={'Pesquisar...'}
          error={error}
          InputProps={{
            ...params.InputProps,
            endAdornment: applyPopupIndicatorTestId(params.InputProps.endAdornment),
          }}
        />
      )}
    />
  );
};

export default ParticipanteAutoComplete;
